import { NgModule } from '@angular/core';
import { MyOffersComponent } from './my-offers.component';
import { ConfigModule, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SafePipe } from '../shared/pipe/safe';
import { DatePipe, NgClass, CommonModule } from '@angular/common';
import { OfferDocumentComponent } from './components/offer-document/offer-document.component';
import { OfferFormComponent } from './components/offer-form/offer-form.component';
import { OfferComponent } from './components/offer/offer.component';
import { TrimSpacesDirective } from './directives/trim-spaces/trim-spaces.directive';
import { FormsModule } from '@angular/forms';
import { OfferPageComponent } from './components/offer-page/offer-page.component';

@NgModule({
  declarations: [
    MyOffersComponent,
    OfferComponent,
    SafePipe,
    OfferDocumentComponent,
    OfferFormComponent,
    TrimSpacesDirective,
    OfferPageComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    I18nModule,
    DatePipe,
    NgClass,
    FormsModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        OfferPageComponent: {
          component: MyOffersComponent, // existing mapping
        },
        // New mapping for the SingleOffer CMS component
        SingleOfferPageComponent: {
          component: OfferPageComponent,
        },
      },
    }),
  ],
  exports: [SafePipe],
  providers: [
    provideConfig({
      i18n: {
        chunks: {
          myOffers: ['myOffers'],
        },
      },
    }),
  ],
})
export class MyOffersModule {}
